const map = (from, to) => {
	Object.keys(from).forEach(arg => {
		to[arg] = from[arg]
	})
	return to
}

function mapTo (from, to) {
	if (!Array.isArray(from)) {
		return map(from, to)
	}

	from.forEach(fr => {
		map(fr, to)
	})

	return to
}

export default mapTo
